var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jdsc-input-area",class:_vm.classes,on:{"click":_vm.emitClick}},[_c('div',{staticClass:"jdsc-input-area__center"},[_vm._t("default")],2),_c('div',{staticClass:"jdsc-input-area__right"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }